export default {"src":"/_next/static/media/Facebook.a38f4230.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};